/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { stringify } from 'qs';
import { InventoryLocationBuildingFloorplan } from '@enmon/commons/lib/tools';
import { StrapiApiResponse } from 'types/strapiResponse';
import { BaseApiClient } from './baseApiClient';

export type Filter<T> = T extends Date
  ? T
  : T extends Record<any, any>
  ? {
      [K in keyof T]?: Filter<T[K]>;
    }
  : T;

export class InventoryLocationBuildingFloorplansApiClient extends BaseApiClient<InventoryLocationBuildingFloorplan> {
  constructor() {
    super('inventory-location-building-floorplans');
  }

  async find({
    floor,
    inv_loc_building,
    inv_location,
  }: Filter<InventoryLocationBuildingFloorplan>): Promise<StrapiApiResponse<InventoryLocationBuildingFloorplan>> {
    return await this.http.get('', {
      params: {
        filters: {
          floor: { $eq: floor },
          $or: [
            {
              inv_loc_building: { id: { $eq: inv_loc_building?.id } },
            },
            {
              inv_location: { id: { $eq: inv_location?.id } },
            },
          ],
        },
        populate: { inv_loc_building: true, inv_location: true },
      },
      paramsSerializer: params => stringify(params, { allowDots: false }),
    });
  }

  async getContent(id: InventoryLocationBuildingFloorplan['id']): Promise<Blob> {
    return await this.http.get(`${id}/content`, {
      responseType: 'blob',
    });
  }
}
